module.exports = __webpack_public_path__ + "img/Questionnaire_PT.2e7f7758.png";